import React from 'react';
import styled from 'styled-components';

import PrimaryButton from '../../atoms/PrimaryButton';

const Container = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 2rem 1.5rem;
`;

const Content = styled.div`
  text-align: center;
  width: 100%;
`;

class TrafficSourceComponent extends React.Component {
  componentDidMount() {
    const script1 = document.createElement('script');
    script1.innerHTML = `
    if (!window.afblpcvLpConf) {
      window.afblpcvLpConf = [];
    }
    window.afblpcvLpConf.push({
      siteId: "5db3898e"
    });
    window.afblpcvLinkConf = {
      siteId: "5db3898e",
      mode: "all"
    };
  `;
    document.body.appendChild(script1);

    const script2 = document.createElement('script');
    script2.src = 'https://t.afi-b.com/jslib/lpcv.js?cid=5db3898e&pid=g8602z';
    script2.async = true;
    document.body.appendChild(script2);
  }

  render() {
    return (
      <Container>
        <Content>
          <PrimaryButton href="https://www.jaic-college.jp/lp/form/api_af_schedule_reservation_thanks/">
            登録
          </PrimaryButton>
        </Content>
      </Container>
    );
  }
}

export default TrafficSourceComponent;
